import { useSelector } from "react-redux";

import Mini from "/components/common/product/mini";
import PopupFormWrapper from "../popupFormWrapper";
import { GOALS } from "../../../../utils/tracking";

const FORM_CODE = "similarProduct";

export default function SimilarProduct() {
  const { data } = useSelector((state) => state.popup);

  return (
    <PopupFormWrapper
      code={FORM_CODE}
      filterField={({ CODE }) => CODE !== "form_text_59"}
      goalOpen={GOALS.similarProductOpen}
      extraData={({ popupData }) =>
        popupData?.name ? { form_text_59: popupData.name } : null
      }
      successText={(r) =>
        `В ближайщее время менеджер свяжется с Вами. Номер заявки #${r.success}`
      }
      goalSent={GOALS.similarProductSent}
    >
      <Mini productId={data?.id} />
    </PopupFormWrapper>
  );
}
